import User from './User';
import Booking from './Booking';
import BookingItem from './BookingItem';
import Leg from './Leg';
import Station from './Station';
import Fare from './Fare';
import Offers from './Offers';
import Offer from './Offer';
import ShiftTransaction from './ShiftTransaction';
import Profile from './Profile';
import takeCustomerPresentCardPayment from './mutations/TakeCustomerPresentCardPayment';
import printReceipt from './mutations/PrintReceipt';
import printTicketsAtb from './mutations/PrintTicketsAtb';
import updateProductsWithSalesforceStatus from './mutations/UpdateProductsWithSalesforceStatus';

const resolvers = {
  Booking,
  Leg,
  User,
  BookingItem,
  Fare,
  Station,
  Offers,
  Offer,
  ShiftTransaction,
  Profile,
  Mutation: {
    printReceipt,
    takeCustomerPresentCardPayment,
    printTicketsAtb,
    updateProductsWithSalesforceStatus
  }
};

export default resolvers;
